<template>
	<div class="hunterInfor">
		<div class="card">
			<div class="card-header" style="background: none; font-size: 20px; font-weight: bold; line-height: 40px;">赏金猎人信息
				<el-button type="primary" style=" float: right; width: auto; margin: 0;">添加赏金猎人</el-button>
			</div>
			<div class="card-body">
				<div class="">
					<el-table :data="tableData" style="width: 100%">
						<el-table-column label="赏金猎人姓名">
							<template slot-scope="scope">
								<div>{{ scope.row.date }}</div>
							</template>
						</el-table-column>
						<el-table-column label="城市">
							<template slot-scope="scope">
								<div>{{ scope.row.date }}</div>
							</template>
						</el-table-column>
						<el-table-column label="业务线">
							<template slot-scope="scope">
								<span>{{ scope.row.name }}</span>
							</template>
						</el-table-column>
						<el-table-column label="业务类型">
							<template slot-scope="scope">
								<span>{{ scope.row.address }}</span>
							</template>
						</el-table-column>
						<el-table-column label="提成比例">
							<template slot-scope="scope">
								<span>{{ scope.row.date }}</span>
							</template>
						</el-table-column>
						<el-table-column label="状态">
							<template slot-scope="scope">
								<span>{{ scope.row.date }}</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		<!-- 分页 -->
		<div class="workbench_paging clearfix">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			 :page-sizes="[100, 200, 300, 400]" :page-size="100" :total="400" layout="total, sizes, prev, pager, next, jumper">
			</el-pagination>
		</div>
		<!-- 分页 -->
	</div>
</template>

<script>
	export default{
		data(){
			return{
				tableData: [{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-02',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-04',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-01',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-08',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-06',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-07',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}]
			}
		},
		methods:{
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			}
		}
	}
</script>

<style lang="less">
	.hunterInfor {
		margin-top: 20px;
	}
</style>
